/**
 * Wspólne etykiety i formatowanie dla ekranów "Rolki" w panelu admina
 * (sekcja w edycji użytkownika, akcja zbiorcza na liście, strona "Rolki").
 */

export const LEDGER_REASON_LABELS = {
  opening_balance: 'Saldo początkowe',
  purchase: 'Zakup pakietu',
  admin_grant: 'Przydział admina',
  admin_revoke: 'Odjęcie przez admina',
  reel: 'Nowa rolka',
  reel_caption_regen: 'Nowy opis',
  reel_regen: 'Regeneracja rolki',
  capture: 'Nagranie (apka)',
  refund: 'Zwrot',
};

export const DISCOUNT_STATUS = {
  active: { label: 'Aktywny', type: 'success' },
  used: { label: 'Wykorzystany', type: 'info' },
  expired: { label: 'Wygasł', type: 'warning' },
  revoked: { label: 'Cofnięty', type: 'danger' },
};

export const PURCHASE_STATUS = {
  paid: { label: 'Opłacony', type: 'success' },
  pending: { label: 'Oczekuje', type: 'warning' },
};

export const DISCOUNT_SOURCE_LABELS = {
  user: 'rabat użytkownika',
  first_purchase: 'pierwszy zakup',
};

export const MAX_AMOUNT = 1000;
export const MAX_DISCOUNT_PERCENT = 90;
export const MAX_DISCOUNT_USES = 100;
export const NOTE_MAX_LENGTH = 255;

export function ledgerReasonLabel(reason) {
  return LEDGER_REASON_LABELS[reason] || reason || '-';
}

export function discountStatus(status) {
  return DISCOUNT_STATUS[status] || { label: status || '-', type: 'info' };
}

export function purchaseStatus(status) {
  return PURCHASE_STATUS[status] || { label: status || '-', type: 'info' };
}

/** Grosze -> "9,50 zł". */
export function formatPriceGr(gr) {
  if (gr === null || gr === undefined || gr === '') {
    return '-';
  }
  return (Number(gr) / 100).toFixed(2).replace('.', ',') + ' zł';
}

/** ISO 8601 -> "07.10.2026 14:05" (czas polski). */
export function formatDateTime(iso) {
  if (!iso) {
    return '-';
  }
  const date = new Date(iso);
  if (isNaN(date.getTime())) {
    return iso;
  }
  return date.toLocaleString('pl-PL', {
    timeZone: 'Europe/Warsaw',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** ISO 8601 albo "Y-m-d" -> "07.10.2026" (czas polski). */
export function formatDate(value) {
  if (!value) {
    return '-';
  }
  const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(value + 'T12:00:00') : new Date(value);
  if (isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleDateString('pl-PL', {
    timeZone: 'Europe/Warsaw',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

/** "1 / 3" albo "0 / bez limitu". */
export function formatDiscountUses(discount) {
  const limit = discount.max_uses === null || discount.max_uses === undefined ? 'bez limitu' : discount.max_uses;
  return (discount.used_count || 0) + ' / ' + limit;
}

/** Nowy, pusty formularz rabatu (procent, liczba użyć / bez limitu, ważny do). */
export function emptyDiscountForm() {
  return {
    percent: 50,
    maxUses: 1,
    unlimited: false,
    expiresAt: null,
  };
}

/** Formularz rabatu -> payload API (`max_uses: null` = bez limitu, `expires_at` jako 'Y-m-d'). */
export function discountPayload(form) {
  return {
    percent: form.percent,
    max_uses: form.unlimited ? null : form.maxUses,
    expires_at: form.expiresAt || null,
  };
}

/** Daty przeszłe są wyłączone w pickerze "Ważny do" (dzisiaj = do końca dnia, dozwolone). */
export function disabledPastDate(time) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return time.getTime() < today.getTime();
}

/** Notatka: pusty tekst nie jest wysyłany jako "". */
export function noteOrNull(note) {
  const trimmed = (note || '').trim();
  return trimmed === '' ? null : trimmed;
}

/**
 * Odmiana "rolka" po liczbie w bierniku: 1 rolkę, 2 rolki, 5 rolek, 22 rolki.
 */
export function reelsCountLabel(n) {
  let word = 'rolek';
  const lastDigit = n % 10;
  const lastTwo = n % 100;
  if (n === 1) {
    word = 'rolkę';
  } else if (lastDigit >= 2 && lastDigit <= 4 && (lastTwo < 12 || lastTwo > 14)) {
    word = 'rolki';
  }
  return n + ' ' + word;
}

/** Pod checkboxem "Powiadom użytkownika" (przydział rolek, rabat, akcja zbiorcza). */
export const NOTIFY_HINT = 'Powiadomienie w serwisie, push w aplikacji i e-mail (bez treści notatki).';

/** Dopisek do komunikatu sukcesu: czy użytkownik dostanie powiadomienie (wysyłka idzie w tle). */
export function notifySuffix(notify) {
  return notify ? 'Użytkownik zostanie powiadomiony.' : 'Bez powiadomienia użytkownika.';
}
